import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const StrikeIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 16 16"
    >
      <path
        d="M6.81665 2.76729H2.44531V0.666626H13.5613V2.76729H9.19131V15.3333H6.81665V2.76729Z"
        fill={color}
      />
      <path
        d="M1.33337 8.66671V7.33337H6.00004V8.66671H1.33337Z"
        fill={color}
      />
      <path d="M10 8.66671V7.33337H14.6667V8.66671H10Z" fill={color} />
    </BaseIcon>
  ),
);

StrikeIcon.displayName = 'StrikeIcon';
